<template>
  <v-select
    :loading="loading"
    :disabled="loading"
    class="no-line-select select-on-transparent"
    multiple
    xs6
    outlined
    hide-details
    :items="bidStages"
    :label="label"
    item-text="id"
    return-object
    :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
    v-model="selectedStages"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="toggle">
        <v-list-item-action>
          <v-icon :color="selectedStages.length > 0 ? 'indigo darken-4' : ''">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("common.select_all") }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <span class="text-no-wrap" v-if="isAllStagesSelected && index === 0">
        {{ $t("common.all") }}
      </span>
      <span class="text-no-wrap mr-2" v-if="!isAllStagesSelected">
        <span
          :style="{
            width: '11px',
            height: '11px',
            background: item.color,
            color: getCorrectTextColor(item.color),
          }"
          class="pa-1 d-inline-block mr-1 status-square"
        ></span>
        <span v-if="selectedStages.length < 5">
          {{
            item.is_system
              ? $t("viewBids.stages." + item.system_name)
              : item.name
          }}
        </span>
      </span>
    </template>
    <template v-slot:item="{ item, attrs }">
      <span class="text-no-wrap">
        <v-icon v-if="attrs['aria-selected'] === 'true'" :color="item.color"
          >mdi-checkbox-marked</v-icon
        >
        <v-icon :color="item.color" v-else>mdi-checkbox-blank</v-icon>
        {{
          item.is_system ? $t("viewBids.stages." + item.system_name) : item.name
        }}
      </span>
    </template>
  </v-select>
</template>
<script>
import CommonMixin from "@/mixins/common";
export default {
  name: "BidStageFilterSelect",
  props: {
    bidStages: Array,
    stage: Object,
    label: null,
    loading: Boolean,
  },
  mixins: [CommonMixin],
  data: () => ({
    selectedStages: [],
    filled: false,
  }),
  mounted() {},
  computed: {
    isAllStagesSelected() {
      return this.selectedStages.length === this.bidStages.length;
    },
    icon() {
      if (this.isAllStagesSelected) return "mdi-close-box";
      if (
        this.selectedStages.length !== this.bidStages.length &&
        this.selectedStages.length > 0
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    bidStages() {
      if (!this.filled) {
        this.toggle();
      }
    },
    selectedStages() {
      if (!this.filled) {
        this.filled = true;
        return;
      }
      let ids = [];
      this.selectedStages.forEach((item) => ids.push(item.id));
      this.$emit("update", ids);
    },
  },
  methods: {
    updateBidStage() {},
    toggle() {
      this.$nextTick(() => {
        if (this.selectedStages.length === this.bidStages.length) {
          this.selectedStages = [];
        } else {
          this.selectedStages = this.bidStages.slice();
        }
      });
    },
  },
};
</script>
